<template>
    <h1 class="title-logo">
        Заказ №{{id}} от 12.02.2022
        <div class="order-card__control">
            <button class="order-card__open-control-btn js-data-popup-open" type="button">
                <svg class="svg-icon-dots svg-icon" width="15" height="5">
                    <use xlink:href="#dots"></use>
                </svg>
            </button>
            <div class="data-popup js-data-popup">
                <div class="data-popup__header">
                    <div class="data-popup__title">Управление</div><button class="data-popup__close-btn js-data-popup-close" type="button"><svg class="svg-icon-close svg-icon" width="20" height="20">
                    <use xlink:href="#close"></use>
                </svg></button>
                </div>
                <div class="data-popup__content">
                    <div class="btns btns--cols"><button class="neutral-btn neutral-btn--success" type="button"><svg class="svg-icon-done svg-icon" width="20" height="20">
                        <use xlink:href="#done"></use>
                    </svg>Заказ выполнен</button><button class="neutral-btn neutral-btn--accent" type="button"><svg class="svg-icon-cancel svg-icon" width="20" height="20">
                        <use xlink:href="#cancel"></use>
                    </svg>Отменить заказ</button></div>
                </div>
            </div>
        </div>
    </h1>
    <div v-if="user.id > 0"  class="order-card">
        <div class="order-card__data">Дата доставки: 20.02.2022</div>
        <div class="order-card__data has-popup"><a href="javascript:;" class="js-data-popup-open">Позиций в заказе: <span>5</span></a>
            <div class="data-popup js-data-popup">
                <div class="data-popup__header">
                    <div class="data-popup__title">Позиции заказа</div><button class="data-popup__close-btn js-data-popup-close" type="button"><svg class="svg-icon-close svg-icon" width="20" height="20">
                    <use xlink:href="#close"></use>
                </svg></button>
                </div>
                <table class="order-content-tbl">
                    <tr>
                        <td>Речной песок</td>
                        <td>10 т</td>
                    </tr>
                    <tr>
                        <td>Щебень</td>
                        <td>10 т</td>
                    </tr>
                    <tr>
                        <td>Доска обрезная <br>50х150х6000</td>
                        <td>10 м<sup>3</sup></td>
                    </tr>
                    <tr>
                        <td>Речной песок</td>
                        <td>10 т</td>
                    </tr>
                    <tr>
                        <td>Щебень</td>
                        <td>10 т</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="order-card__data has-popup">
            <div class="one-line"><a href="javascript:;" class="js-data-popup-open">Место доставки: <span class="remote-data" data-source-id="adr-2">г. Москва, ул. Московская, 15</span></a></div>
            <div class="data-input-control js-data-popup-open">
                <div class="data-input-control__popup data-popup js-data-popup">
                    <div class="data-popup__header"><button class="data-popup__close-btn js-data-popup-close" type="button"><svg class="svg-icon-close svg-icon" width="20" height="20">
                        <use xlink:href="#close"></use>
                    </svg></button></div>
                    <div class="data-popup__content"><label for="adr-2">Адрес</label><input class="js-source-input" type="text" id="adr-2" value="г. Москва, ул. Московская, 15"></div>
                    <div class="bottom-section"><button class="data-input-control__close-btn primary-btn lg-btn wide-btn js-data-popup-close" type="button"><span>Сохранить</span></button></div>
                </div>
            </div>
        </div>
        <div class="check-wrap check-wrap--single"><input type="checkbox" id="agree"><label for="agree"><span></span><span>Сбор предложений от поставщиков&nbsp;<span class="tooltip tooltip--inline js-open-modal" data-modal-id="msg"><svg class="svg-icon-info svg-icon" width="18" height="18"><use xlink:href="#info"></use></svg></span></span></label></div>
        <div class="supplies scrollable js-scroll">
            <div class="supply-item">
                <div class="supply-item__person">
                    <div class="supply-item__name">Иванов Пётр</div>
                    <div class="supply-item__rating rating">
                        <div class="rating__value">4.3</div><a class="rating__link" href="javascript:;">31 оценка</a>
                    </div>
                </div>
                <div class="supply-item__content"><span>Позиции 5 из 10&nbsp;<span class="tooltip tooltip--inline js-open-modal" data-modal-id="msg"><svg class="svg-icon-info svg-icon" width="18" height="18"><use xlink:href="#info"></use></svg></span></span></div>
                <div class="supply-item__comment"><span>Комментарий:</span><span>Какой-то комментарий от пользователя, если был</span></div>
                <div class="supply-item__controls">
                    <div class="supply-item__sum">124 000 руб.</div><button class="supply-item__btn supply-item__btn--edit" type="button">Выбрать</button>
                </div>
            </div>
            <div class="supply-item">
                <div class="supply-item__person">
                    <div class="supply-item__name">Иванов Пётр</div>
                    <div class="supply-item__rating rating">
                        <div class="rating__value">4.3</div><a class="rating__link" href="javascript:;">31 оценка</a>
                    </div>
                </div>
                <div class="supply-item__content"><span>Позиции 5 из 10&nbsp;<span class="tooltip tooltip--inline js-open-modal" data-modal-id="msg"><svg class="svg-icon-info svg-icon" width="18" height="18"><use xlink:href="#info"></use></svg></span></span></div>
                <div class="supply-item__comment"><span>Комментарий:</span><span>Какой-то комментарий от пользователя, если был</span></div>
                <div class="supply-item__controls">
                    <div class="supply-item__sum">124 000 руб.</div><button class="supply-item__btn supply-item__btn--edit" type="button">Выбрать</button>
                </div>
            </div>
            <div class="supply-item">
                <div class="supply-item__person">
                    <div class="supply-item__name">Иванов Пётр</div>
                    <div class="supply-item__rating rating">
                        <div class="rating__value">4.3</div><a class="rating__link" href="javascript:;">31 оценка</a>
                    </div>
                </div>
                <div class="supply-item__content"><span>Позиции 5 из 10&nbsp;<span class="tooltip tooltip--inline js-open-modal" data-modal-id="msg"><svg class="svg-icon-info svg-icon" width="18" height="18"><use xlink:href="#info"></use></svg></span></span></div>
                <div class="supply-item__comment"><span>Комментарий:</span><span>Какой-то комментарий от пользователя, если был</span></div>
                <div class="supply-item__controls">
                    <div class="supply-item__sum">124 000 руб.</div><button class="supply-item__btn supply-item__btn--edit" type="button">Выбрать</button>
                </div>
            </div>
            <div class="supply-item">
                <div class="supply-item__person">
                    <div class="supply-item__name">Иванов Пётр</div>
                    <div class="supply-item__rating rating">
                        <div class="rating__value">4.3</div><a class="rating__link" href="javascript:;">31 оценка</a>
                    </div>
                </div>
                <div class="supply-item__content"><span>Позиции 5 из 10&nbsp;<span class="tooltip tooltip--inline js-open-modal" data-modal-id="msg"><svg class="svg-icon-info svg-icon" width="18" height="18"><use xlink:href="#info"></use></svg></span></span></div>
                <div class="supply-item__comment"><span>Комментарий:</span><span>Какой-то комментарий от пользователя, если был</span></div>
                <div class="supply-item__controls">
                    <div class="supply-item__sum">124 000 руб.</div><button class="supply-item__btn supply-item__btn--edit" type="button">Выбрать</button>
                </div>
            </div>
        </div>
    </div>
    <p v-else>Для просмотра списка ваших заказов вам необходимо пройти  <router-link to="/auth">авторизацию</router-link></p>
    <div class="modal" id="msg">
        <div class="modal__inner">
            <p>Идет сбор предложений от поставщиков, вам будет необходимо выбрать одно из предожений</p>
        </div>
    </div>
</template>

<script>

    import IMask from 'imask';

    export default {

        name: 'OrderDetail',

        props: ['id'],

        data: function(){
            return {

            };
        },

        computed: {
            user: function () {
                return this.$store.getters.getUser;
            },
        },

        created() {
            this.$root.scrollable = false;
            this.$root.pageClass = "";
        },

        mounted:function () {

        },

        components: {},

        methods: {}
    }
</script>
